import { render, staticRenderFns } from "./fhorder.vue?vue&type=template&id=798fe222&scoped=true&"
import script from "./fhorder.vue?vue&type=script&lang=js&"
export * from "./fhorder.vue?vue&type=script&lang=js&"
import style0 from "./fhorder.vue?vue&type=style&index=0&id=798fe222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798fe222",
  null
  
)

export default component.exports